import { ProjektprognosErrorBar } from './ProjektprognosErrorBar'
import { ProjektprognosInfoBar } from './ProjektprognosInfoBar'
import { SystemBar } from '../../SystemState/ErrorManagement/MessageBars/SystemBar'

export const ProjektprognosNotificationBars = () => {
  return (
    <>
      <ProjektprognosErrorBar />

      <ProjektprognosInfoBar />

      <SystemBar />
    </>
  )
}
